export default {
  footerText: "rgba(255, 255, 255, 0.8)",
  composerTextColor: "#ffffff",
  composerBorderColor: "rgba(255, 255, 255, 0.5)",
  composerBackgroundColor: "rgba(255, 255, 255, 0.12)",
  composerIconColor: "rgba(255, 255, 255, 0.6)",
  composerIconHoverColor: "#ffffff",
  endUserMessageBackgroundColor: "rgba(255, 255, 255, 0.7)",
  endUserMessageTextColor: "#333333",
  agentMessageBackgroundColor: "#f5f8fa",
  agentMessageTextColor: "#333333",
  messageAuthorColor: "rgba(255, 255, 255, 0.70)",
  messageTimestampColor: "rgba(255, 255, 255, 0.70)",
  conversationRatingHeaderTextColor: "rgba(53, 63, 69, 0.6)",
  conversationRatingHeaderBackgroundColor: "rgba(104, 120, 130, 0.12)",
  conversationRatingBodyBackgroundColor: "rgba(104, 120, 130, 0.12)",
  gdprTextColor: 'rgba(255, 255, 255, 0.8)',
  buttonBackgroundColor: "#e5e5e5",
  buttonTextColor: "#222222",
}

